module.exports = __webpack_public_path__ + "img/Couch-Coffee-Table-Trap-Icon-WFH.dc62dc77.png";